import FileMeta from "./FileMeta";


/**
 * 
 */
export default interface ImageFileSet {
  image?: FileMeta;
  cut?: FileMeta;
}


export const convertFileMetasToImageFileSetMap = (fileMetas: FileMeta[]) => {
  let copiedMetas = [...fileMetas];
  let imageDic = new Map<string, ImageFileSet>();

  for (let idx = 0; idx < copiedMetas.length; idx++) {
    let ele = copiedMetas[idx];
    const value = imageDic.get(ele.name);
    if (value) {
      if (ele.ext === "svg") {
        value.cut = ele;
        imageDic.set(ele.name, value);
      } else {
        value.image = ele;
        imageDic.set(ele.name, value);
      }
    } else {
      if (ele.ext === "svg") {
        imageDic.set(ele.name, {
          cut: ele
        });
      } else {
        imageDic.set(ele.name, {
          image: ele
        });
      }
    }
  }

  return imageDic;
}